import { Link } from 'react-router'
import { useTranslation } from 'react-i18next'
import { NewsCard } from '../news/NewsCard'
import { CompetitionCard } from '../competitions/CompetitionCard'
import type { HomeNews } from './useHomeNews'

interface Props {
  news: HomeNews
  gymSlug: string
}

/**
 * Home's Noutăți tab: the competitions, events and unread news worth knowing
 * about today, each with the way to its full page.
 */
export function HomeNewsPanel({ news, gymSlug }: Props) {
  const { t } = useTranslation()
  const { competitions, events, news: posts, joinEvent, leaveEvent } = news

  return (
    <div className="flex flex-col gap-5">
      {competitions.length > 0 && (
        <section className="flex flex-col gap-2" aria-label={t('competitions.pageTitle')}>
          <Heading label={t('competitions.pageTitle')} to="/competitions" more={t('home.seeAll')} />
          {competitions.map((c) => (
            <CompetitionCard key={c.id} competition={c} />
          ))}
        </section>
      )}
      {events.length > 0 && (
        <section className="flex flex-col gap-2" aria-label={t('events.pageTitle')}>
          <Heading
            label={t('events.pageTitle')}
            to={`/${gymSlug}/events`}
            more={t('home.seeAll')}
          />
          {events.map((item) => (
            <NewsCard key={item.id} item={item} join={{ onJoin: joinEvent, onLeave: leaveEvent }} />
          ))}
        </section>
      )}
      {posts.length > 0 && (
        <section className="flex flex-col gap-2" aria-label={t('news.pageTitle')}>
          <Heading label={t('news.pageTitle')} to={`/${gymSlug}/news`} more={t('home.seeAll')} />
          {posts.map((item) => (
            <NewsCard key={item.id} item={item} />
          ))}
        </section>
      )}
    </div>
  )
}

function Heading({ label, to, more }: { label: string; to: string; more: string }) {
  return (
    <div className="flex items-baseline justify-between gap-2 px-1">
      <p className="eyebrow text-foreground/40">{label}</p>
      <Link to={to} className="text-xs font-semibold text-[var(--gym-primary)]">
        {more} →
      </Link>
    </div>
  )
}
